import React from "react";
import { EVIDENCIA_STATUS_VARIANT } from "@/constants";

const FALLBACK = "bg-muted text-muted-foreground border border-border";

export function EvidenciaStatusBadge({ status, className = "", size = "sm", ...props }) {
  const variant = EVIDENCIA_STATUS_VARIANT[status] || FALLBACK;
  const sizeCls =
    size === "xs"
      ? "text-[10px] px-1.5 py-0.5"
      : size === "md"
      ? "text-sm px-3 py-1"
      : "text-xs px-2 py-0.5";
  return (
    <span
      className={`inline-flex items-center rounded-md font-medium uppercase tracking-wider whitespace-nowrap ${sizeCls} ${variant} ${className}`}
      {...props}
    >
      {status || "—"}
    </span>
  );
}

export default EvidenciaStatusBadge;
